module.exports = __webpack_public_path__ + "static/media/KaTeX_Main-Regular.756fad0d.woff";